import { NgModule } from '@angular/core';
import { SharedComponentsModule } from '../../shared/module/shared-components.module';
import {
  BestDealWorstDealChartComponent,
} from '../component/a/best-deal-worst-deal-chart/best-deal-worst-deal-chart.component';

import {
  ContributionVintageChartComponent,
} from '../component/market/contribution-vintage-chart/contribution-vintage-chart.component';
import {
  CompanyCardChartComponent,
} from '../../company-performance/round/charts/company-card-chart/company-card-chart.component';
import {
  PortfolioPerformanceChartComponent,
} from '../component/portfolio-performance-chart/portfolio-performance-chart.component';
import {
  NetFundPerformanceChartComponent,
} from '../component/net-fund-performance-chart/net-fund-performance-chart.component';
import {
  ModalCompanyMetricChartComponent,
} from '../../kpi/modals/modal-company-metric-chart/modal-company-metric-chart.component';
import {
  CompanyOneMetricChartComponent,
} from '../component/a/company-one-metric-chart/company-one-metric-chart.component';
import {
  CompanyOneMetricComparisonChartComponent,
} from '../component/a/company-one-metric-comparison-chart/company-one-metric-comparison-chart.component';
import {
  FairValueAndPpChartsComponent,
} from '../../organization/components/fair-value-and-pp-charts/fair-value-and-pp-charts.component';
import { DataBehindFvAndPpChartsComponent }
  from '../../organization/components/fair-value-and-pp-charts/data-behind-fv-and-pp-charts/data-behind-fv-and-pp-charts.component';
import { BasePieChartComponent } from '../../organization/components/fair-value-and-pp-charts/base-pie-chart/base-pie-chart.component';
import { BaseBarDrilldownChartComponent }
  from '../../organization/components/fair-value-and-pp-charts/base-bar-drilldown-chart/base-bar-drilldown-chart.component';
import { BaseBarChartComponent } from '../../organization/components/fair-value-and-pp-charts/base-bar-chart/base-bar-chart.component';
import {
  BaseBarSyncScrollChartComponent,
} from '../../base-charts/base-bar-sync-scroll-chart/base-bar-sync-scroll-chart.component';
import {
  ValueCreationChartsComponent,
} from '../../fund-performance/component/shared/value-creation-charts/value-creation-charts.component';
import { FpPieChartsComponent } from '../../pp/component/sub/pp-overview/fp-pie-charts/fp-pie-charts.component';
import { FundPerformanceSharedModule } from '../../fund-performance/module/fund-performance-shared.module';
import { PieChartSimpleComponent } from "../../shared/component/pie-chart-simple/pie-chart-simple.component";
import {
  TableGroupIconComponent,
} from "../../shared/component/icons-deprecated/table-group-icon/table-group-icon.component";

@NgModule({
  declarations: [
    BasePieChartComponent,
    BaseBarChartComponent,
    BaseBarDrilldownChartComponent,
    BaseBarSyncScrollChartComponent,
    PortfolioPerformanceChartComponent,
    NetFundPerformanceChartComponent,
    BestDealWorstDealChartComponent,
    ContributionVintageChartComponent,
    CompanyCardChartComponent,
    ModalCompanyMetricChartComponent,
    CompanyOneMetricChartComponent,
    CompanyOneMetricComparisonChartComponent,
    FairValueAndPpChartsComponent,
    DataBehindFvAndPpChartsComponent,
    ValueCreationChartsComponent,
    FpPieChartsComponent,
  ],

  imports: [SharedComponentsModule, FundPerformanceSharedModule, PieChartSimpleComponent, TableGroupIconComponent],

  exports: [
    BasePieChartComponent,
    BaseBarChartComponent,
    BaseBarDrilldownChartComponent,
    BaseBarSyncScrollChartComponent,
    PortfolioPerformanceChartComponent,
    NetFundPerformanceChartComponent,
    BestDealWorstDealChartComponent,
    ContributionVintageChartComponent,
    CompanyCardChartComponent,
    ModalCompanyMetricChartComponent,
    CompanyOneMetricChartComponent,
    CompanyOneMetricComparisonChartComponent,
    FairValueAndPpChartsComponent,
    DataBehindFvAndPpChartsComponent,
    ValueCreationChartsComponent,
    FpPieChartsComponent,
  ],
})
export class ChartModule {}
